.otherLocationsRow {
  padding-top: 24px;
}

.otherLocationsRow > div:first-of-type {
  margin-bottom: 8px;
}

.locationCard {
  border-radius: 24px;
  border: 2px solid transparent;
  background-color: var(--colors-grays-ultralight);
  padding: 18px 20px;
  max-width: 300px;
  cursor: pointer;
  height: 100%;
}

.selectedLocationCard {
  border-color: var(--colors-grays-black);
}

@media (--reefer-media-tablet-min) {
  .otherLocationsRow {
    padding-top: 0px;
  }

  .otherLocationsRow > div:first-of-type {
    margin-bottom: 0px;
  }
}
